<template>
  <v-navigation-drawer
    app
    left
    clipped
    mini-variant
    mini-variant-width="56"
    permanent
    class="d-flex align-end flex-column "
  >
    <v-list-item class="px-2 pt-4">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-list-item-avatar
            v-on="on"
            color="#64B5F6"
            size="36"
            class="nav-user-avatar ma-2"
            style="position:absolute;margin:-6px 3px 0 1px !important;"
          >
            <span class="user-initials white--text subtitle-1">{{
              user ? user.initials : ""
            }}</span>
          </v-list-item-avatar>
        </template>
        <span>{{ user ? user.longName : "" }}</span>
      </v-tooltip>
    </v-list-item>
    <v-divider></v-divider>
    <v-list dense nav>
      <v-list-item @click="navigateTo('customers')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('customers')"
                >mdi-account-group</v-icon
              >
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Customers</span>
        </v-tooltip>
      </v-list-item>
      <!-- <v-list-item @click="navigateTo('reports')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('reports')">mdi-home</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Home</span>
        </v-tooltip>
      </v-list-item> -->
      <v-list-item @click="navigateTo('reviews')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('reviews')">mdi-star</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Ratings &amp; Reviews</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item @click="navigateTo('calls')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-badge color="error" dot :value="callNotificationCount"
                ><v-icon :color="routeColor('calls')"
                  >mdi-phone</v-icon
                ></v-badge
              >
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Calls</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item @click="navigateTo('messages')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-badge color="error" dot :value="messageNotificationCount"
                ><v-icon :color="routeColor('messages')"
                  >mdi-message</v-icon
                ></v-badge
              >
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Messages</span>
        </v-tooltip>
      </v-list-item>
      <!-- <v-list-item @click="navigateTo('chats')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-badge color="error" dot :value="chatNotificationCount"
                ><v-icon :color="routeColor('chats')">mdi-chat</v-icon></v-badge
              >
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Chats</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item @click="navigateTo('reports')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('reports')">mdi-chart-line</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Reports</span>
        </v-tooltip>
      </v-list-item> -->
      <!-- <v-list-item @click="navigateTo('tracking')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('tracking')">mdi-radar</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Tracking</span>
        </v-tooltip>
      </v-list-item> -->
      <v-list-item @click="navigateTo('settings')">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('settings')">mdi-cog</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Settings</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-spacer></v-spacer>
    <v-list class="bottom-left-global-nav">
      <v-list-item @click="logout">
        <v-tooltip right>
          <template v-slot:activator="{ on }">
            <v-list-item-action v-on="on" class="mx-0">
              <v-icon :color="routeColor('settings')">mdi-logout</v-icon>
            </v-list-item-action>
            <v-btn color="primary" dark v-on="on">Right</v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "LeftNavigation",
  components: {},
  data() {
    return {};
  },
  async created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    callNotificationCount() {
      return this.settings ? this.settings.callIsUnreadCount : 0;
    },
    chatNotificationCount() {
      return this.settings
        ? this.settings.chatIsUnreadCount +
            this.settings.chatHaveNotRespondedCount
        : 0;
    },
    messageNotificationCount() {
      return this.settings
        ? this.settings.messageIsUnreadCount +
          this.settings.messageHaveNotRespondedCount
        : 0;
    }
  },
  methods: {
    navigateTo(routeName) {
      if (this.$route.name != routeName) {
        this.$store.dispatch("entities/users/update", {
          where: this.userId,
          data: { currentCustomerId: null }
        });
        this.$router.push({ name: routeName });
      }
    },
    routeColor(routeName) {
      return this.$route.name == routeName ? "secondary" : "light";
    },
    logout() {
      this.$root.$children[0].logout();
    }
  },
  watch: {}
};
</script>

<style lang="stylus" scoped>
div.nav-user-avatar {
  margin-left: 0 !important;
}
div.nav-user-avatar span.user-initials {
  margin: 0 auto;
}
div.bottom-left-global-nav {
  bottom: 0;
  position: absolute;
}
</style>
